<template>
  <div id="change-password">
    <v-card class="card-shadow border-radius-xl mt-4">
      <v-card-title class="pb-0 d-flex align-center">
        <h6 class="mb-0 text-h6 text-typo font-weight-bold">變更密碼</h6>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="error" type="error" dismissible @input="error = null">
          {{ error }}
        </v-alert>
        <v-alert
          v-if="success"
          type="success"
          dismissible
          @input="success = null"
        >
          {{ success }}
        </v-alert>

        <v-form ref="form" v-model="valid">
          <v-row>
            <!-- Current Password (only for employee role) -->
            <v-col cols="12" md="6" v-if="isEmployee">
              <v-text-field
                v-model="form.currentPassword"
                label="舊密碼"
                :type="showCurrentPassword ? 'text' : 'password'"
                :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showCurrentPassword = !showCurrentPassword"
                :rules="currentPasswordRules"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <!-- New Password -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.newPassword"
                label="新密碼"
                :type="showNewPassword ? 'text' : 'password'"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showNewPassword = !showNewPassword"
                :rules="newPasswordRules"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>

            <!-- Confirm New Password -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.confirmPassword"
                label="確認新密碼"
                :type="showConfirmPassword ? 'text' : 'password'"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                :rules="confirmPasswordRules"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-btn
                @click="submit"
                :loading="saving"
                :disabled="!valid"
                elevation="0"
                :ripple="false"
                height="43"
                color="#5e72e4"
                class="
                  font-weight-bold
                  text-uppercase
                  btn-primary
                  bg-gradient-primary
                  py-2
                  px-6
                  me-2
                  mt-7
                  mb-2
                "
              >
                變更密碼
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ChangePasswordWidget",
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      saving: false,
      error: null,
      success: null,
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      currentPasswordRules: [(v) => !!v || "舊密碼為必填"],
      newPasswordRules: [
        (v) => !!v || "新密碼為必填",
        (v) => (v && v.length >= 8) || "新密碼至少需要8個字元",
      ],
      confirmPasswordRules: [
        (v) => !!v || "確認新密碼為必填",
        (v) => v === this.form.newPassword || "新密碼與確認密碼不一致",
      ],
    };
  },
  computed: {
    ...mapGetters({
      userRole: "user/userRole",
    }),
    isEmployee() {
      return this.userRole === "employee";
    },
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.saving = true;
      this.error = null;
      this.success = null;

      try {
        if (this.isEmployee) {
          // Employee: use /api/users/my/change-password with current password
          await this.$axios.post("/api/users/my/change-password", {
            currentPassword: this.form.currentPassword,
            newPassword: this.form.newPassword,
          });
        } else {
          // Other roles: use /api/users/{id}/change-password with only new password
          await this.$axios.post(`/api/users/${this.userId}/change-password`, {
            newPassword: this.form.newPassword,
          });
        }

        this.success = "密碼變更成功";
        this.resetForm();
      } catch (err) {
        console.error("Error changing password:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.error = err.response.data.message;
        } else {
          this.error = "密碼變更失敗，請稍後再試";
        }
      } finally {
        this.saving = false;
      }
    },
    resetForm() {
      this.form = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.$refs.form.resetValidation();
    },
  },
};
</script>
